import { render } from "./PanelError.vue?vue&type=template&id=e08a5108"
import script from "./PanelError.vue?vue&type=script&lang=js"
export * from "./PanelError.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__